
<div class="card-header" role="tab" [attr.id]="'heading-' + idx">
    <span class="mb-0">
        <a (click)="toggleCard()" data-toggle="collapse" [attr.href]="'#collapse-' + idx"
           [attr.aria-expanded]="'false'"
           [attr.aria-controls]="'collapse-' + idx">
            {{question.question.text}}
        </a>
    </span>
</div>
<!--[class.in]="idx=='new'"-->
<div *ngIf="_activated" [attr.id]="'collapse-' + idx" class="collapse question-detail-container" role="tabpanel"
     [attr.aria-labelledby]="'heading-' + idx">
    <div class="card-block questionCard">
        <textarea class="form-control" cols="44" rows="4" id="questionText"
                  [(ngModel)]="question.question.text"></textarea>

        <div class="row">
            <div class="form-group col-xs-6">
                <div class="form-check">
                    <label class="form-check-label" for="taiType">
                        <input id="taiType" type="checkbox" [checked]="question.presentation == 'GR'"
                               (click)="changePresentation('GR')">TAI</label>
                </div>

            </div>
            <div class="form-group col-xs-6">
                <div class="form-check">
                    <label class="form-check-label" for="quizType">
                        <input class="form-check-input" id="quizType" type="checkbox"
                               [checked]="question.presentation == 'Q'"
                               (click)="changePresentation('Q')">Quiz</label>
                </div>

            </div>
        </div>

        <div class="form-group" *ngIf="question.presentation == 'GR'"><label>Lightbulb Sentence:</label>
            <p *ngIf="taiSentence != null" >
                <span *ngFor="let word of taiSentence.words"> {{word.word}} </span>
            </p>
            <p *ngIf="taiSentence == null" >
                <span> (not defined; select a sentence in the text) </span>
            </p>
        </div>

        <div class="form-group">
            <label class="form-label" for="skillText">Skill</label>
            <select id="skillText" [(ngModel)]="question.skill">
                <option>{{dropdownDefault}}</option>
                <option *ngFor="let skill of skillValues" value={{skill}}>
                    {{skill}}
                </option>
            </select>
        </div>

        <div class="form-group">
            <label class="form-label" for="thinkingText">Thinking</label>
            <select id="thinkingText" [(ngModel)]="question.thinking">
                <option>{{dropdownDefault}}</option>
                <option *ngFor="let thinking of thinkingValues" value={{thinking}}>
                    {{thinking}}
                </option>
            </select>
        </div>

        <div class="form-group">
            <div class="btn-group">
                <button type="button" [class.btn-outline-primary]='question.type == "MultipleChoice"'
                        [class.btn-outline-secondary]='question.type != "MultipleChoice"'
                        class="btn btn-outline-secondary btn-sm" (click)="changeType('MultipleChoice')">
                    Multiple Choice
                </button>
                <button type="button" [class.btn-outline-primary]='question.type == "MultipleChecks"'
                        [class.btn-outline-secondary]='question.type != "MultipleChecks"'
                        class="btn btn-outline-secondary btn-sm" (click)="changeType('MultipleChecks')">
                    Multiple Correct
                </button>
                <button type="button" [class.btn-outline-primary]='question.type == "TrueFalse"'
                        [class.btn-outline-secondary]='question.type != "TrueFalse"'
                        class="btn btn-outline-secondary btn-sm" (click)="changeType('TrueFalse')">
                    True | False
                </button>
                <button type="button" [class.btn-outline-primary]='question.type == "OpenBook"'
                        [class.btn-outline-secondary]='question.type != "OpenBook"'
                        class="btn btn-outline-secondary btn-sm" (click)="changeType('OpenBook')">
                    OpenBook
                </button>
                <button type="button" [class.btn-outline-primary]='question.type == "Prompt"'
                        [class.btn-outline-secondary]='question.type != "Prompt"'
                        class="btn btn-outline-secondary btn-sm" (click)="changeType('Prompt')">
                    Prompt
                </button>
            </div>
        </div>


        <div>

            <div *ngIf="question.type == 'MultipleChoice' || question.type == 'TrueFalse'
                || question.type == 'MultipleChecks'">

                <div class="card" *ngFor="let answer of question.answers; let answerIndex = index">

                    <div class="card-block">
                        <textarea class="form-control" cols="44" rows="2" id="answerText"
                                  [(ngModel)]="answer.text"></textarea>
                        <label class="form-control-label"><input type="checkbox" [(ngModel)]="answer.correct"
                                                                 checked>Correct</label>

                        <div class="row">
                            <div class="col-md-12">
                                <button class="btn btn-danger btn-sm pull-md-right"
                                        (click)="deleteAnswer(answerIndex)">Delete
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="card-block" *ngFor="let hint of answer.hints; let hintIndex = index">
                        <span>{{hint.text}}</span>


                    </div>

                    <div class="row" *ngIf="showAddHint">
                        <input type="input" [(ngModel)]="newHint.text">
                    </div>

                </div>

                <div class="card-block form-group">
                    <button class="btn btn-outline-success btn-sm pull-md-right" *ngIf="!showAddAnswer"
                            (click)="showAddNewAnswer()">Add Answer
                    </button>

                </div>

            </div>

            <div *ngIf="question.type == 'OpenBook'">
                <div class="row" *ngIf="editingSentence">
                    <div class="form-group col-md-12" *ngIf="openBookSentence">Answer Sentence (click on a different sentence to change):
                        <span *ngFor="let word of openBookSentence.words"> {{word.word}} </span>
                    </div>
                    <div class="form-group col-md-12" *ngIf="!openBookSentence">
                        Click on a sentence at the left.
                    </div>

                </div>
                <div class="row" *ngIf="editingSentence">
                    <div class="form-group col-md-12">
                        <button class="btn btn-outline-success btn-sm" (click)="finalizeOpenBookSentence()">Save
                            Answer Sentence
                        </button>
                    </div>
                </div>
                <div class="row" *ngIf="!editingSentence">
                    <div class="form-group col-md-12" *ngIf="openBookSentence">Answer Sentence:
                        <span *ngFor="let word of openBookSentence.words"> {{word.word}} </span>
                    </div>
                    <div class="form-group col-md-12">
                        <button class="btn btn-outline-success btn-sm" (click)="editOpenBookSentence()">Edit Answer Sentence
                        </button>
                    </div>
                </div>
            </div>

            <div class="btn-group">
                <button class="btn btn-info" type="button" [disabled]="addInProgress" (click)="checkValidQuestion()">
                    Check Question Data
                </button>
                <button class="btn btn-success" type="button" [disabled]="addInProgress || question.question.text == ''" (click)="save()">
                    Save
                </button>
                <button class="btn btn-danger" type="button" (click)="deleteQuestion()">Delete</button>
            </div>
        </div>
    </div>
</div>
